import { chain, uniq } from 'lodash';

type ColumnConfig = {
  column: string;
};

const buildFieldList = (columns: ColumnConfig[]): Record<string, string[]> => chain(columns)
  .flatMap(({ column }) => column.split(',').map((s) => s.trim()))
  .map((path) => {
    const [prefix, field] = path.split('.');
    return prefix && field ? { prefix, field } : null;
  })
  .filter((item): item is { prefix: string; field: string } => !!item)
  .groupBy('prefix')
  .mapValues((items) => uniq(items.map((item) => item.field)))
  .value();

export default buildFieldList;
